import * as React from "react"

const PICKER_BREAKPOINT = 1366

export function useIsPickerSelectMode() {
  const [isPickerMode, setIsPickerMode] = React.useState<boolean>(false)

  React.useEffect(() => {
    const updateMode = () => {
      const width = window.innerWidth
      const hasCoarsePointer = window.matchMedia("(pointer: coarse)").matches
      const isTouchDevice = navigator.maxTouchPoints > 1

      setIsPickerMode(width < PICKER_BREAKPOINT || hasCoarsePointer || isTouchDevice)
    }

    updateMode()

    window.addEventListener("resize", updateMode)
    return () => window.removeEventListener("resize", updateMode)
  }, [])

  return isPickerMode
}
